import { Phone, ArrowDown } from "lucide-react";
import { COMPANY, HERO_IMAGE } from "@/data/site";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="LVM Drywall commercial project — finished drywall in a warehouse"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-navy-950/80" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/50 to-transparent" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-8 pb-24 pt-32">
        <div className="max-w-4xl fade-up">
          <p className="font-display text-sm sm:text-base font-bold uppercase tracking-[0.3em] text-brand-light mb-6">
            Residential · Commercial · Remodeling
          </p>
          <h1
            data-testid="hero-heading"
            className="font-display font-black uppercase text-white text-5xl sm:text-6xl lg:text-[5.5rem] leading-[0.9] tracking-tighter"
          >
            From Frame
            <br />
            <span className="text-brand-light">To Finish.</span>
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-zinc-300 max-w-2xl leading-relaxed">
            {COMPANY.name} delivers expert drywall installation, finishing,
            framing, and acoustical ceilings — with reliable service and
            professional results on every project.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={COMPANY.phoneHref}
              data-testid="hero-call-button"
              className="group flex items-center justify-center gap-3 bg-brand hover:bg-brand-dark text-navy-950 font-display font-bold uppercase tracking-wide text-base px-8 py-5 transition-colors"
            >
              <Phone className="w-5 h-5" />
              Call {COMPANY.phone}
            </a>
            <a
              href="#work"
              data-testid="hero-work-button"
              className="flex items-center justify-center gap-3 border-2 border-navy-600 hover:border-brand text-white font-display font-bold uppercase tracking-wide text-base px-8 py-5 transition-colors"
            >
              View Our Work
            </a>
          </div>
        </div>
      </div>

      <a
        href="#services"
        className="absolute bottom-8 right-8 hidden lg:flex items-center justify-center w-12 h-12 border border-navy-600 text-zinc-300 hover:text-brand-light hover:border-brand transition-colors animate-bounce"
        aria-label="Scroll to services"
      >
        <ArrowDown className="w-5 h-5" />
      </a>
    </section>
  );
};
